import DOMPurify from "dompurify";

import { Checkbox } from "../../../components/ui/common/checkbox";
import { Label } from "../../../components/ui/common/label";
import { ScrollArea } from "../../../components/ui/common/scroll-area";

interface SupplierTermsConsentProps {
  termsHtml: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  error?: string;
}

/**
 * Supplier-only terms acceptance shown on Reset Password when
 * `useCheckUserByEmail` reports `isSupplier`. The terms come from the backend
 * as HTML (`SupplierUserCheck.terms`) and are sanitised before being rendered.
 */
export const SupplierTermsConsent = ({
  termsHtml,
  checked,
  onCheckedChange,
  error
}: SupplierTermsConsentProps) => (
  <div className="tw-space-y-3">
    <ScrollArea className="tw-h-56 tw-rounded-lg tw-border tw-border-input tw-bg-background tw-p-4 tw-text-sm">
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsHtml) }} />
    </ScrollArea>
    <div className="tw-flex tw-items-center tw-gap-2">
      <Checkbox
        id="supplier-terms-consent"
        checked={checked}
        aria-invalid={!!error}
        onCheckedChange={value => onCheckedChange(value === true)}
      />
      <Label htmlFor="supplier-terms-consent" className="tw-cursor-pointer tw-font-normal">
        Supplier Terms &amp; Conditions
      </Label>
    </div>
    {error && (
      <p role="alert" className="tw-text-xs tw-text-destructive">
        {error}
      </p>
    )}
  </div>
);
